<template>
	<div class="form" v-if="loaded">
		<div class="step_title">{{ words.step }} {{ step }}</div>
		<h2 class="title">{{ words.hey }} {{ form.first_name }}, {{ words.whats_your_address }}</h2>
		<form class="small_form" @submit.prevent="$emit('saveData', {...form, community_id: selectedCommunity.id})">
			<!-- <div class="small_title">{{ words.whats_your_city }}</div>
			<template v-if="city_info && city_info.name != ''">
				<div class="input_like">
					<div >{{ city_info.name }} </div>
					<a @click="city_info = ''" class="change_btn">{{ words.change_number }}</a>
				</div>
			</template>
			<template v-else>
				<div class="form-item">
					<Select2 v-model="selectedCity" :required="true" :settings="settingsCity" @select="onSelectCity()" @click="focus_input()"/>
				</div>
			</template> -->
			<div class="small_title">{{ words.community_input_label }}</div>
			<template v-if="community_info && community_info.name">
				<div class="input_like">
					<div >{{ city_info.name }} </div>
					<a @click="community_info = ''" class="change_btn">{{ words.change_number }}</a>
				</div>
			</template>
			<template v-else>
				<div class="form-item">
					<Select2 v-model="selectedCommunity.id" :required="true" :settings="settingsCommunity"  @click="focus_input()"/>
				</div>
			</template>
			<!-- <div class="small_title" v-if="openStreet">{{ words.whats_your_street }}</div>
			<div class="form-item" v-if="openStreet" id="street_wrapper" @click="focus_input()">
				<Select2 v-model="selectedStreet" :required="true" :settings="settingsStreet" />
			</div> -->
			<div class="small_title">{{ words.whats_your_address }}</div>
			<div class="options">
				<div class="form-item">
					<input type="text" id="city" v-model="form.city" autocomplete="off" required/>
					<label for="city">{{ words.city }}</label>
				</div>
				<div class="form-item">
					<input type="text" id="street" v-model="form.street" autocomplete="off" required />
					<label for="street">{{ words.street }}</label>
				</div>
			</div>

			<div class="options">
				<div class="form-item">
					<input @keypress="isNumber($event)" inputmode="numeric" type="text" id="house_num" v-model="form.house_num" autocomplete="off" required/>
					<label for="house_num">{{ words.house_num }}</label>
				</div>
				<!-- <div class="form-item">
					<input @keypress="isNumber($event)" inputmode="numeric" type="text" id="zip" v-model="form.zip" autocomplete="off" required oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="9"/>
					<label for="zip">{{ words.zip }}</label>
				</div> -->
			</div>
			<div class="btn_wrapper">
				<a class="go_back under_line" @click="$emit('returnStep')" tabindex="0">{{ words.return_step }}</a>
				<input type="submit" class="btn" :value="words.procced" />
			</div>
		</form>
	</div>
</template>

<script>
import Select2 from 'vue3-select2-component';
export default {
	props: {
		numbersInfo: {
			required: true,
			type: Array,
		},
		step: {
			required: true,
			type: Number,
		},
		numbers: {
			required: true,
			type: Array,
		},
		parentForm: {
			required: true,
			type: Object,
		},
   },
  data() {
    return {
		form:{

		},
		cities: [],
		city_info: {},
		community_info: {},
		street_info: {},
		selectedCity: {},
		selectedCommunity: {
			id: ''
		},
		loaded: false,
		openStreet: false,
		selectedStreet:{},
		isLoading: false,
		// settingsCity: {
		// 	language: {
		// 			noResults(){ return this.get_word('no_results');},
		// 			searching() { return this.get_word('searching'); }
		// 		},
		// 		dir: "rtl",
		// 	ajax: {
		// 		url: window.api_url + 'get_cities',
		// 		headers:{"Authorization" : localStorage.getItem('user_token')},
		// 		data(params) {
		// 			var query = {
		// 				search: params.term,
		// 				_type: 'query',
		// 				name: params.term
		// 			};	  
		// 			return query;
		// 		},
		// 		processResults(response) {
		// 			let list = response.data.items; 
		// 			var ret = [];
		// 			for (let i in list) ret.push({id: list[i].id, text: list[i].name});
		// 			return {
		// 				results:ret
		// 			};
		// 		},
			
		// 	}
		// },
		settingsCommunity: {
			language: {
					
				},
				dir: "rtl",
			ajax: {
				url: window.api_url + 'get_communities',
				headers:{"Authorization" : localStorage.getItem('user_token')},
				data(params) {
					var query = {
						search: params.term,
						_type: 'query',
						name: params.term
					};	  
					return query;
				},
				processResults(response) {
					let list = response.data.items; 
					var ret = [];
					for (let i in list) ret.push({id: list[i].id, text: list[i].name});
					return {
						results:ret
					};
				},
			
			}
		},
		settingsStreet: {
			language: {
					noResults(){ return "לא נמצאו תוצאות";},
					searching() { return "מחפש.."; }
				},
				dir: "rtl",
				ajax: {
				url: window.api_url + 'get_streets',
				headers:{"Authorization" : localStorage.getItem('user_token')},
				data(params) {
					var query = {
						search: params.term,
						_type: 'query',
						name: params.term
					};	  
					return query;
				},
				processResults (response) {
					let list = response.data.items; 
					var ret = [];
					for (let i in list) ret.push({id: list[i].id, text: list[i].name});
					return {
						results:ret
					};
				},
			
			}
		},
	}
  },
   mounted() {
	if (this.parentForm && Object.entries(this.parentForm).length) this.form = {...this.parentForm, ...this.form}
	const self = this;
	this.settingsCommunity.language = {
		noResults(){ return self.words.no_results;},
		searching() { return self.words.searching; }
	}

	// this.api({ action: 'cart/get_city_info', method: 'post' }, (data) => {
	// 	if(data.data.city) this.city_info = data.data.city;
	// 	if(data.data.street) this.street_info = data.data.street;
	// 	this.loaded = true;
	// });

	this.api({ action: 'cart/get_community_info', method: 'post' }, (data) => {
		if(data.data.city) this.city_info = data.data.city;
		if(data.data.street) this.street_info = data.data.street;
		this.loaded = true;
	});


	
  },
  computed: {
    words() {
      return this.$store.state.words
    },
  },
  methods: {
	onSelectCity() {
		this.api({action: 'cart/save_city',data: { city: this.selectedCity }});
		this.openStreet = true
		
	},
	onSelectCommunity() {
		this.api({action: 'cart/save_community',data: { community: this.selectedCommunity.id }});
		
	},
	focus_input(){
		setTimeout(()=>{
			document.querySelector('.select2-search__field').focus();
		},100)
	}
  },
components: {Select2},
}
</script>

<style scoped>
	.input_like{align-items: center;justify-content: space-between; background: #fff;border: none;border-radius: 7.5px;box-shadow: 0 2.5px 20px -5px #8224e3;height: 50px;text-align: right; padding: 0px 15px; display: flex; margin-bottom: 10px;}
	.input_like a{font-size: 15px;font-weight: 900;text-decoration: underline;}
</style>

